import Vue from 'vue';
import HashIds from 'hashids';

export default () => {
  Vue.use((v) => {
    v.hashids = new HashIds('', 8);
    v.prototype.$hashids = new HashIds('', 8);
  });
};
